/**
 * Main App Component
 * Entry point with routing configuration
 */

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import FormPenilaian from './components/FormPenilaian';
import './App.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/form/:karyawanNama" element={<FormPenilaian />} />
    </Routes>
  );
}

export default App;
